import * as React from "react"

import { cn } from "@/lib/utils"
import { ChampDate } from "./champ-date"

const CLASSES_INPUT =
  "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  // T-262 : toute date passe par le champ JJ/MM/AAAA unique (jamais le champ natif).
  if (type === "date") {
    return <ChampDate ref={ref} className={cn(CLASSES_INPUT, className)} {...props} />
  }
  return (
    <input
      type={type}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
